import axios from 'axios'

export default {
  findBy: (barcode) => axios.get(`/api/affiliations/${barcode}`)
}
